import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef, useState, useCallback } from 'react';
const VideoControlContext = createContext(undefined);
export const useVideoControlContext = () => {
    const context = useContext(VideoControlContext);
    if (!context) {
        throw new Error('useVideoControlContext must be used within VideoControlProvider');
    }
    return context;
};
export const VideoControlProvider = ({ children }) => {
    const videoRef = useRef(null);
    const [hasVideo, setHasVideo] = useState(false);
    const togglePlayPause = useCallback(() => {
        if (videoRef.current && hasVideo) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            }
            else {
                videoRef.current.pause();
            }
        }
    }, [hasVideo]);
    const isPlaying = useCallback(() => {
        return videoRef.current && hasVideo ? !videoRef.current.paused : false;
    }, [hasVideo]);
    return (_jsx(VideoControlContext.Provider, { value: {
            videoRef,
            togglePlayPause,
            isPlaying,
            hasVideo,
            setHasVideo
        }, children: children }));
};
